module.exports = __webpack_public_path__ + "static/img/process_mobile.84d1f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gene_second/PCR_cloning/process_mobile.png
// module id = u9bO
// module chunks = 16